var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSolicitation } from "@/hooks/useSolicitation";
import { ResponseModel } from "@/models/ResponseModel";
import { ROUTES } from "@/routes/routes";
import GatewayService from "@/services/api/GatewayService";
import { zodResolver } from "@hookform/resolvers/zod";
import { isAxiosError } from "axios";
import { format, isValid, parse } from "date-fns";
import { createContext, useCallback, useContext, useMemo, useState, } from "react";
import { FormProvider as FormProviderHookForm, useForm, } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "sonner";
import { z } from "zod";
var DEFAULT_VALUES = {
    registerNumber: "",
    cpf: "",
    birthDate: "",
    applicantName: "",
};
var FormContext = createContext({});
export var useFormContext = function () {
    var context = useContext(FormContext);
    if (!context) {
        throw new Error("useFormContext must be used within a FormProvider");
    }
    return context;
};
var ONLY_NUMBERS_REGEX = /\D/g;
export var FormProvider = function (_a) {
    var children = _a.children, selectedTab = _a.selectedTab;
    var saveData = useSolicitation().saveData;
    var history = useHistory();
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var isTabCpf = selectedTab === "cpf";
    var isTabRegister = selectedTab === "registerNumber";
    var formSchema = z.object({
        registerNumber: z
            .string()
            .optional()
            .refine(function (value) {
            if (selectedTab === "registerNumber") {
                var newValue = (value || "").replace(ONLY_NUMBERS_REGEX, "");
                return newValue.length >= 9 && newValue.length <= 11;
            }
            else {
                return true;
            }
        }, {
            message: "Número de registro inválido. Ele deve ter entre 9 e 11 dígitos.",
        }),
        cpf: z
            .string()
            .optional()
            .refine(function (value) {
            if (selectedTab === "cpf") {
                var newValue = (value || "").replace(ONLY_NUMBERS_REGEX, "");
                if (newValue.length === 11) {
                    return { message: "cpf errado" };
                }
            }
            else {
                return true;
            }
        }, { message: "CPF inválido. Campo deve conter 11 caracteres numéricos." }),
        birthDate: z
            .string()
            .min(10, {
            message: "",
        })
            .max(10)
            .refine(function (value) {
            var parsedDate = parse(value, "dd/MM/yyyy", new Date());
            return (isValid(parsedDate) && format(parsedDate, "dd/MM/yyyy") === value);
        }, { message: "Data de nascimento inválida" }),
        applicantName: z.string().min(1, {
            message: "Nome do requerente é inválido. Não pode ser nulo.",
        }),
    });
    var form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: DEFAULT_VALUES,
    });
    function removeSpecialCharacters(value) {
        return value === null || value === void 0 ? void 0 : value.replace(ONLY_NUMBERS_REGEX, "");
    }
    var onSubmit = useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var service, formattedRequest, response, e_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setIsLoading(true);
                    service = new GatewayService();
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    formattedRequest = {
                        cpf: isTabCpf ? removeSpecialCharacters(values.cpf) : "",
                        registro: isTabRegister
                            ? removeSpecialCharacters(values.registerNumber)
                            : "",
                        nome: values.applicantName,
                        dataNascimento: format(parse(values.birthDate, "dd/MM/yyyy", new Date()), "yyyyMMdd"),
                    };
                    return [4 /*yield*/, service.solicitarPid(formattedRequest)];
                case 2:
                    response = _d.sent();
                    if (ResponseModel.isOk(response)) {
                        saveData(response.data);
                        history.push(ROUTES.SOLICITACAO_CRIADA);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _d.sent();
                    if (isAxiosError(e_1)) {
                        toast.error(((_b = (_a = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || "Erro desconhecido");
                    }
                    else {
                        toast.error(((_c = e_1 === null || e_1 === void 0 ? void 0 : e_1.data) === null || _c === void 0 ? void 0 : _c.message) || (e_1 === null || e_1 === void 0 ? void 0 : e_1.message) || "Erro desconhecido");
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [history, isTabCpf, isTabRegister, saveData]);
    function onError(errors, event) {
        return;
    }
    var contextValues = useMemo(function () { return ({ isLoading: isLoading, selectedTab: selectedTab, setIsLoading: setIsLoading, onError: onError, onSubmit: onSubmit }); }, [isLoading, onSubmit, selectedTab]);
    return (_jsxs(FormContext.Provider, __assign({ value: contextValues }, { children: [_jsx(FormProviderHookForm, __assign({}, form, { children: children })), ";"] })));
};
